import {
    Box,
    Button,
    Divider,
    FormControlLabel,
    Grid,
    Paper,
    Switch,
    TextField,
    Typography,
    useMediaQuery,
} from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Info, Refresh, Save, Schedule, Settings } from "@material-ui/icons"
import { useSnackbar } from "../../../utils/notificacoes"
import React, { useEffect, useState } from "react"
import {
    atualizarConfiguracaoAgendamento,
    buscarConfiguracoesAgendamento,
    cadastrarConfiguracoesAgendamento,
} from "../../../services/apiAgendamento"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"
import Cabecalho from "../../Cabecalho"
import { Loading } from "../../RegistradorDePedidos"

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "90px",
        paddingRight: "10px",
        paddingTop: "100px",
        paddingBottom: "30px",
        [theme.breakpoints.down("md")]: {
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "80px",
        },
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "70px",
        },
    },
    content: {
        margin: "auto",
        maxWidth: "800px",
        [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
        },
    },
    header: {
        marginBottom: theme.spacing(4),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(1),
            marginBottom: theme.spacing(3),
        },
    },
    headerTitle: {
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(0.5),
        },
    },
    titleText: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.5rem",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "1.25rem",
        },
    },
    configCard: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        backgroundColor: "white",
        overflow: "hidden",
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            borderRadius: 15,
            marginBottom: theme.spacing(2),
        },
    },
    cardHeader: {
        backgroundColor: "#f8f9fa",
        padding: theme.spacing(2.5),
        borderBottom: "2px solid #e9ecef",
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
            flexWrap: "wrap",
        },
    },
    cardHeaderTitle: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.1rem",
        },
    },
    cardContent: {
        padding: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    fieldContainer: {
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            marginBottom: theme.spacing(2),
        },
    },
    textField: {
        backgroundColor: "white",
        "& .MuiOutlinedInput-root": {
            borderRadius: 12,
            "& fieldset": {
                borderColor: "#e0e0e0",
            },
            "&:hover fieldset": {
                borderColor: "#4caf50",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#4caf50",
            },
        },
    },
    legend: {
        display: "flex",
        alignItems: "flex-start",
        marginTop: theme.spacing(1),
        color: "#7f8c8d",
        fontSize: "0.875rem",
        lineHeight: 1.4,
        "& svg": {
            marginRight: theme.spacing(0.5),
            fontSize: "1rem",
            marginTop: "2px",
            flexShrink: 0,
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.8rem",
        },
    },
    buttonContainer: {
        display: "flex",
        gap: theme.spacing(2),
        justifyContent: "center",
        marginTop: theme.spacing(4),
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            gap: theme.spacing(1.5),
            marginTop: theme.spacing(3),
        },
    },
    saveButton: {
        borderRadius: 25,
        backgroundColor: "var(--cor-botao-salvar)",
        color: "white",
        padding: theme.spacing(1.5, 4),
        fontWeight: 600,
        boxShadow: "0 4px 15px rgba(var(--cor-botao-salvar-rgb), 0.3)",
        minWidth: "180px",
        "&:hover": {
            backgroundColor: "var(--cor-botao-salvar-hover)",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(var(--cor-botao-salvar-rgb), 0.4)",
        },
        [theme.breakpoints.down("sm")]: {
            minWidth: "100%",
            padding: theme.spacing(2, 3),
        },
    },
    resetButton: {
        borderRadius: 25,
        backgroundColor: "var(--cor-erro)",
        color: "white",
        padding: theme.spacing(1.5, 4),
        fontWeight: 600,
        boxShadow: "0 4px 15px rgba(244, 67, 54, 0.3)",
        minWidth: "180px",
        "&:hover": {
            backgroundColor: "var(--cor-erro-hover)",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(244, 67, 54, 0.4)",
        },
        [theme.breakpoints.down("sm")]: {
            minWidth: "100%",
            padding: theme.spacing(2, 3),
        },
    },
    iconHeader: {
        color: "#4caf50",
        marginRight: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.2rem",
        },
    },
    switchContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: theme.spacing(1),
        backgroundColor: "#f8f9fa",
        borderRadius: 12,
        marginTop: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1.5),
        },
    },
    exampleText: {
        color: "#7f8c8d",
        fontStyle: "italic",
        textAlign: "center",
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.85rem",
            textAlign: "left",
        },
    },
}))

export function ConfiguracoesAgendamento() {
    const classes = useStyles()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const setLoading = useLoadingStore(s => s.setLoading)
    const autorizacao = localStorage.getItem("chaveSistema")
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }
    const configuracoesEst = useAppStore(s => s.configuracoes)
    const idEstabelecimento = configuracoesEst.user.parametros.estabelecimento.id

    const [configuracoes, setConfiguracoes] = useState({})

    const handleBuscarConfiguracoesAgendamento = async () => {
        setLoading(true)
        try {
            const response = await buscarConfiguracoesAgendamento(idEstabelecimento, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                const retornoCriarConfiguracoes = await cadastrarConfiguracoesAgendamento(
                    idEstabelecimento,
                    autorizacao
                )
                if (!retornoCriarConfiguracoes.retornoErro) {
                    handleBuscarConfiguracoesAgendamento()
                }
            } else {
                setConfiguracoes(response)
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        handleBuscarConfiguracoesAgendamento()
    }, [])

    const handleInputChange = (campo, valor) => {
        setConfiguracoes(prev => ({
            ...prev,
            [campo]: valor,
        }))
    }

    const handleSalvar = async () => {
        try {
            setLoading(true)
            if (configuracoes.pedidosPorIntervalo <= 0) {
                alertStart("Pedidos por intervalo deve ser maior que zero", "error")
                return
            }
            if (configuracoes.intervaloMinutos <= 0) {
                alertStart("Intervalo em minutos deve ser maior que zero", "error")
                return
            }
            if (configuracoes.tempoMinimoHoras < 0) {
                alertStart("Tempo mínimo não pode ser negativo", "error")
                return
            }
            if (configuracoes.tempoMaximoDias <= 0) {
                alertStart("Tempo máximo deve ser maior que zero", "error")
                return
            }

            const response = await atualizarConfiguracaoAgendamento(
                configuracoes,
                idEstabelecimento,
                autorizacao
            )
            if (response.retornoErro) {
                alertStart("Erro ao atualizar", "error")
            } else {
                alertStart("Configurações salvas com sucesso!", "success")
            }
        } catch (error) {
            alertStart("Erro ao salvar configurações", "error")
        } finally {
            setLoading(false)
        }
    }

    const handleResetar = async () => {
        try {
            setLoading(true)

            const data = {
                pedidosPorIntervalo: 5,
                intervaloMinutos: 30,
                tempoMinimoAgendamentoHoras: 24,
                tempoMaximoAgendamentoDias: 7,
                aceiteAutomatico: true,
            }

            const response = await atualizarConfiguracaoAgendamento(
                data,
                idEstabelecimento,
                autorizacao
            )
            if (response.retornoErro) {
                alertStart("Erro ao atualizar", "error")
            } else {
                setConfiguracoes(data)
                alertStart("Configurações resetadas", "info")
            }
        } catch {
            alertStart("Erro ao resetar configurações", "error")
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Loading />
            <Cabecalho pagina={"Configurações de Agendamento"} />
            <div className={classes.container}>
                <div className={classes.content}>
                    <Box className={classes.header}>
                        <Box className={classes.headerTitle}>
                            <Box display="flex" alignItems="center">
                                <Typography variant="h4" className={classes.titleText}>
                                    Configurações de Agendamento
                                </Typography>
                            </Box>
                            <Typography variant="subtitle1" style={{ color: "#7f8c8d" }}>
                                Gerencie as regras do sistema de agendamento
                            </Typography>
                        </Box>
                    </Box>

                    <Paper className={classes.configCard}>
                        <Box className={classes.cardHeader}>
                            <Settings className={classes.iconHeader} />
                            <Typography variant="h6" className={classes.cardHeaderTitle}>
                                Configurações de Capacidade
                            </Typography>
                        </Box>
                        <Box className={classes.cardContent}>
                            <Grid container spacing={isMobile ? 2 : 3}>
                                <Grid item xs={12} sm={12} md={6}>
                                    <Box className={classes.fieldContainer}>
                                        <Typography
                                            variant="subtitle1"
                                            style={{ marginBottom: 8, fontWeight: 500 }}
                                        >
                                            Pedidos por Intervalo
                                        </Typography>
                                        <TextField
                                            className={classes.textField}
                                            variant="outlined"
                                            size="small"
                                            type="number"
                                            fullWidth
                                            value={configuracoes.pedidosPorIntervalo}
                                            onChange={e =>
                                                handleInputChange(
                                                    "pedidosPorIntervalo",
                                                    parseInt(e.target.value) || 0
                                                )
                                            }
                                            inputProps={{ min: 1 }}
                                        />
                                        <Typography className={classes.legend}>
                                            <Info />
                                            Quantos pedidos podem ser agendados no mesmo intervalo
                                            de tempo
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <Box className={classes.fieldContainer}>
                                        <Typography
                                            variant="subtitle1"
                                            style={{ marginBottom: 8, fontWeight: 500 }}
                                        >
                                            Intervalo (minutos)
                                        </Typography>
                                        <TextField
                                            className={classes.textField}
                                            variant="outlined"
                                            size="small"
                                            type="number"
                                            fullWidth
                                            value={configuracoes.intervaloMinutos}
                                            onChange={e =>
                                                handleInputChange(
                                                    "intervaloMinutos",
                                                    parseInt(e.target.value) || 0
                                                )
                                            }
                                            inputProps={{ min: 1 }}
                                        />
                                        <Typography className={classes.legend}>
                                            <Info />
                                            Duração do intervalo de tempo em minutos (ex: 30
                                            minutos)
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>

                            <Divider style={{ margin: "24px 0" }} />

                            <Typography variant="body2" className={classes.exampleText}>
                                Exemplo: {configuracoes.pedidosPorIntervalo} pedidos podem ser
                                agendados a cada {configuracoes.intervaloMinutos} minutos
                            </Typography>
                        </Box>
                    </Paper>

                    <Paper className={classes.configCard}>
                        <Box className={classes.cardHeader}>
                            <Schedule className={classes.iconHeader} />
                            <Typography variant="h6" className={classes.cardHeaderTitle}>
                                Configurações de Tempo
                            </Typography>
                        </Box>
                        <Box className={classes.cardContent}>
                            <Grid container spacing={isMobile ? 2 : 3}>
                                <Grid item xs={12} sm={12} md={6}>
                                    <Box className={classes.fieldContainer}>
                                        <Typography
                                            variant="subtitle1"
                                            style={{ marginBottom: 8, fontWeight: 500 }}
                                        >
                                            Tempo Mínimo (horas)
                                        </Typography>
                                        <TextField
                                            className={classes.textField}
                                            variant="outlined"
                                            size="small"
                                            type="number"
                                            fullWidth
                                            value={configuracoes.tempoMinimoAgendamentoHoras}
                                            onChange={e =>
                                                handleInputChange(
                                                    "tempoMinimoAgendamentoHoras",
                                                    parseInt(e.target.value) || 0
                                                )
                                            }
                                            inputProps={{ min: 0 }}
                                        />
                                        <Typography className={classes.legend}>
                                            <Info />
                                            Tempo mínimo de antecedência para fazer um agendamento
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <Box className={classes.fieldContainer}>
                                        <Typography
                                            variant="subtitle1"
                                            style={{ marginBottom: 8, fontWeight: 500 }}
                                        >
                                            Tempo Máximo (dias)
                                        </Typography>
                                        <TextField
                                            className={classes.textField}
                                            variant="outlined"
                                            size="small"
                                            type="number"
                                            fullWidth
                                            value={configuracoes.tempoMaximoAgendamentoDias}
                                            onChange={e =>
                                                handleInputChange(
                                                    "tempoMaximoAgendamentoDias",
                                                    parseInt(e.target.value) || 0
                                                )
                                            }
                                            inputProps={{ min: 1 }}
                                        />
                                        <Typography className={classes.legend}>
                                            <Info />
                                            Quantos dias no futuro é possível fazer agendamentos
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>

                    <Paper className={classes.configCard}>
                        <Box className={classes.cardHeader}>
                            <Settings className={classes.iconHeader} />
                            <Typography variant="h6" className={classes.cardHeaderTitle}>
                                Configurações
                            </Typography>
                        </Box>
                        <Box className={classes.cardContent}>
                            <Box className={classes.fieldContainer}>
                                <Typography
                                    variant="subtitle1"
                                    style={{ marginBottom: 8, fontWeight: 500 }}
                                >
                                    Aceite Automático
                                </Typography>
                                <Box className={classes.switchContainer}>
                                    <Typography variant="body2" style={{ color: "#2c3e50" }}>
                                        {configuracoes.aceiteAutomatico ? "Ativado" : "Desativado"}
                                    </Typography>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={Boolean(configuracoes.aceiteAutomatico)}
                                                onChange={e =>
                                                    handleInputChange(
                                                        "aceiteAutomatico",
                                                        e.target.checked
                                                    )
                                                }
                                                color="primary"
                                            />
                                        }
                                        label=""
                                    />
                                </Box>
                                <Typography className={classes.legend}>
                                    <Info />
                                    {configuracoes.aceiteAutomatico
                                        ? "Pedidos agendados serão aceitos automaticamente"
                                        : "Pedidos agendados precisarão ser aceitos manualmente"}
                                </Typography>
                            </Box>
                            <Box className={classes.fieldContainer}>
                                <Typography
                                    variant="subtitle1"
                                    style={{ marginBottom: 8, fontWeight: 500 }}
                                >
                                    Permitir pedidos agendados apenas fora do horário
                                </Typography>
                                <Box className={classes.switchContainer}>
                                    <Typography variant="body2" style={{ color: "#2c3e50" }}>
                                        {configuracoes.agendamentoApenasForaDoHorario
                                            ? "Ativado"
                                            : "Desativado"}
                                    </Typography>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={Boolean(
                                                    configuracoes.agendamentoApenasForaDoHorario
                                                )}
                                                onChange={e =>
                                                    handleInputChange(
                                                        "agendamentoApenasForaDoHorario",
                                                        e.target.checked
                                                    )
                                                }
                                                color="primary"
                                            />
                                        }
                                        label=""
                                    />
                                </Box>
                                <Typography className={classes.legend}>
                                    <Info />
                                    {configuracoes.agendamentoApenasForaDoHorario
                                        ? "Clientes só poderão agendar pedidos fora do horário de funcionamento"
                                        : "Clientes poderão agendar pedidos em qualquer horário"}
                                </Typography>
                            </Box>
                            <Box className={classes.fieldContainer}>
                                <Typography
                                    variant="subtitle1"
                                    style={{ marginBottom: 8, fontWeight: 500 }}
                                >
                                    Exigir pagamento online para pedidos agendados
                                </Typography>
                                <Box className={classes.switchContainer}>
                                    <Typography variant="body2" style={{ color: "#2c3e50" }}>
                                        {configuracoes.agendadoApenasPagamentoOnline
                                            ? "Ativado"
                                            : "Desativado"}
                                    </Typography>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={Boolean(
                                                    configuracoes.agendadoApenasPagamentoOnline
                                                )}
                                                onChange={e =>
                                                    handleInputChange(
                                                        "agendadoApenasPagamentoOnline",
                                                        e.target.checked
                                                    )
                                                }
                                                color="primary"
                                            />
                                        }
                                        label=""
                                    />
                                </Box>
                                <Typography className={classes.legend}>
                                    <Info />
                                    {configuracoes.agendadoApenasPagamentoOnline
                                        ? "Pedidos agendados só serão aceitos com pagamento online — pagamento na entrega não estará disponível para esse tipo de pedido"
                                        : "Pedidos agendados poderão ser pagos online ou na entrega"}
                                </Typography>
                            </Box>
                            <Box className={classes.fieldContainer}>
                                <Typography
                                    variant="subtitle1"
                                    style={{ marginBottom: 8, fontWeight: 500 }}
                                >
                                    Agendamento ativo
                                </Typography>
                                <Box className={classes.switchContainer}>
                                    <Typography variant="body2" style={{ color: "#2c3e50" }}>
                                        {configuracoes.agendamentoAtivo ? "Ativado" : "Desativado"}
                                    </Typography>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={Boolean(configuracoes.agendamentoAtivo)}
                                                onChange={e =>
                                                    handleInputChange(
                                                        "agendamentoAtivo",
                                                        e.target.checked
                                                    )
                                                }
                                                color="primary"
                                            />
                                        }
                                        label=""
                                    />
                                </Box>
                                <Typography className={classes.legend}>
                                    <Info />
                                    {configuracoes.agendamentoAtivo
                                        ? "O agendamento de pedidos está habilitado para os clientes"
                                        : "O agendamento de pedidos está desativado"}
                                </Typography>
                            </Box>
                            <Box className={classes.fieldContainer}>
                                <Typography
                                    variant="subtitle1"
                                    style={{ marginBottom: 8, fontWeight: 500 }}
                                >
                                    Retirada apenas com agendamento
                                </Typography>
                                <Box className={classes.switchContainer}>
                                    <Typography variant="body2" style={{ color: "#2c3e50" }}>
                                        {configuracoes.retiradaApenasAgendamento
                                            ? "Ativado"
                                            : "Desativado"}
                                    </Typography>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={Boolean(
                                                    configuracoes.retiradaApenasAgendamento
                                                )}
                                                onChange={e =>
                                                    handleInputChange(
                                                        "retiradaApenasAgendamento",
                                                        e.target.checked
                                                    )
                                                }
                                                color="primary"
                                            />
                                        }
                                        label=""
                                    />
                                </Box>
                                <Typography className={classes.legend}>
                                    <Info />
                                    {configuracoes.retiradaApenasAgendamento
                                        ? "Pedidos de retirada só poderão ser feitos por agendamento"
                                        : "Pedidos de retirada poderão ser feitos sem agendamento"}
                                </Typography>
                            </Box>
                        </Box>
                    </Paper>

                    <Box className={classes.buttonContainer}>
                        <Button
                            className={classes.resetButton}
                            startIcon={!isMobile && <Refresh />}
                            onClick={handleResetar}
                            size={isMobile ? "large" : "medium"}
                        >
                            {isMobile ? "🔄 Resetar" : "Resetar"}
                        </Button>
                        <Button
                            className={classes.saveButton}
                            startIcon={!isMobile && <Save />}
                            onClick={handleSalvar}
                            size={isMobile ? "large" : "medium"}
                        >
                            {isMobile ? "💾 Salvar Configurações" : "Salvar Configurações"}
                        </Button>
                    </Box>
                </div>
            </div>
        </>
    )
}
